import { z } from 'zod/v4';
import { StatusEnum } from './status';
import { TQLHILinkTypeDTO } from './hi-link';
import { SeverityDTO } from './severity';

// HIDTO
export const HIDTO = z.object({
  hi_type_name: z.string(),
  hi_id: z.string(),
  name: z.string(),
  label: z.string(),
  value: z.number(),
  change_status: z.string(),
  update_at: z.iso.datetime(),
  annotation: z
    .object({
      summary: z.string().optional(),
      description: z.string().optional(),
    })
    .optional(),
});
export type HI = z.infer<typeof HIDTO>;

// SummaryHIValuesSchema
export const SummaryHIValuesDTO = z.object({
  value: z.number(),
  count: z.number(),
});
export type SummaryHIValues = z.infer<typeof SummaryHIValuesDTO>;

// GroupHIValuesResponse
export const GroupHIValuesResponseDTO = z.object({
  hi_type_id: z.uuid(),
  status: z.array(SummaryHIValuesDTO),
});
export type GroupHIValuesResponse = z.infer<typeof GroupHIValuesResponseDTO>;

// HIPropagationLinkSchema
export const HIPropagationLinkDTO = z.object({
  hi_id: z.uuid(),
  hi_type_name: z.string(),
  weight: z.number(),
  status: z.nativeEnum(StatusEnum),
  ci_id_src: z.uuid(),
  ci_id_dst: z.uuid(),
});
export type HIPropagationLink = z.infer<typeof HIPropagationLinkDTO>;

// HIActiveHighLevel
export const HIActiveHighLevelDTO = z.object({
  hi_type_name: z.string(),
  value: z.number(),
  count: z.number(),
});
export type HIActiveHighLevel = z.infer<typeof HIActiveHighLevelDTO>;

// HIActive
export const HIActiveDTO = z.object({
  id: z.uuid(),
  ci_id: z.uuid(),
  ci_name: z.string(),
  ci_type_name: z.string(),
  change_status: z.string(),
  hi_type_name: z.string(),
  expression: z.string(),
  template_name: z.string(),
  template_label: z.string(),
  template_description: z.string(),
  annotation: z
    .object({
      summary: z.string().optional(),
      description: z.string().optional(),
    })
    .optional(),
  update_at: z.iso.datetime(),
  type: TQLHILinkTypeDTO,
  value: z.number(),
  has_depends: z.boolean(),
});
export type HIActive = z.infer<typeof HIActiveDTO>;

// Compact active-HI projection used by the header notification popover. The
// endpoint returns one (worst) indicator per CI and the total number of active
// indicators for that CI in `his_count`.
export const HIActiveHighLevelCIDTO = z.object({
  hi_id: z.string(),
  tql_hi_link_id: z.string(),
  ci_id: z.string(),
  ci_name: z.string(),
  ci_type_name: z.string(),
  ci_type_label: z.string().optional(),
  hi_type_name: z.string(),
  hi_type_label: z.string().optional(),
  worst_severity: SeverityDTO,
  worst_duration_sec: z.number(),
  his_count: z.number().int(),
});
export type HIActiveHighLevelCI = z.infer<typeof HIActiveHighLevelCIDTO>;